import { ClerkProvider } from '@clerk/clerk-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { FlagProvider } from '@unleash/proxy-client-react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './sentry.client.config.ts'
import { queryClient } from './services/queryClient.ts'

const config = {
  url: import.meta.env.VITE_UNLEASH_URL,
  clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY,
  refreshInterval: 60,
  appName: 'csview'
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
        <FlagProvider config={config}>
          <App />
        </FlagProvider>
      </ClerkProvider>
    </QueryClientProvider>
  </StrictMode>
)
